import LogoutIcon from '@mui/icons-material/Logout';
import { Logo } from '@pages/Auth/Logo';
import { trackingStore } from '@stores/Tracking';
import { userStore } from '@stores/User';
import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';
import css from './PaywallBar.module.scss';

/**
 * The only chrome a walled user gets: the logo, a way between the plans and the account's
 * billing settings, and log out. Replaces the sidebar while the paywall is up.
 */
export const PaywallBar = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const onWall = location.pathname === '/subscribe';

  const logout = () => {
    trackingStore.userMenuItemClicked({ item: 'logout' });
    userStore.logout();
  };

  return (
    <header className={css.bar}>
      <Logo href="/subscribe" />
      <nav className={css.actions}>
        {onWall ? (
          <button
            type="button"
            className={css.action}
            onClick={() => navigate('/settings/billing')}
          >
            Billing &amp; account
          </button>
        ) : (
          <button type="button" className={css.action} onClick={() => navigate('/subscribe')}>
            Plans
          </button>
        )}
        <button type="button" className={css.action} onClick={logout}>
          <LogoutIcon fontSize="small" />
          Log out
        </button>
      </nav>
    </header>
  );
});
